<template>
    <div class="variant-attributes">
        <div class="section" style="margin-top: 20px;">
            <h3>变体信息</h3>
            <div class="action-buttons">
                <el-button type="primary" size="small" @click="handleAddRelatedProduct">关联已有产品</el-button>
                <el-button type="success" size="small" @click="handleAddNewVariant">添加新变体</el-button>
                <el-button type="primary" @click="handleSubmit">保存</el-button>
            </div>
            <el-table :data="allVariants" border style="margin-top: 20px;" height="300px">
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column label="图片" width="100">
                    <template slot-scope="scope">
                        <div class="image-container" @click="handleSelectImage(scope.row)">
                            <el-image
                                v-if="scope.row.imagesJson && scope.row.imagesJson.mainImages && scope.row.imagesJson.mainImages[0]"
                                :src="scope.row.imagesJson.mainImages[0]"
                                :preview-src-list="scope.row.imagesJson.mainImages"
                                style="width: 50px; height: 50px;"></el-image>
                            <div v-else
                                style="width: 50px; height: 50px; background: #f5f7fa; display: flex; align-items: center; justify-content: center;">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="SKU" prop="sku">
                    <template slot="header">
                        <span class="required">SKU *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isNew" v-model="scope.row.sku" placeholder="请输入SKU"></el-input>
                        <span v-else>{{ scope.row.sku }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name">
                    <template slot="header">
                        <span class="required">名称 *</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isNew" v-model="scope.row.name" placeholder="请输入名称"></el-input>
                        <span v-else>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="型号" prop="model">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isNew" v-model="scope.row.model" placeholder="请输入型号"></el-input>
                        <span v-else>{{ scope.row.model }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="品牌" prop="brand">
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.isNew" v-model="scope.row.brand" placeholder="请输入品牌"></el-input>
                        <span v-else>{{ scope.row.brand }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleDeleteProduct(scope.$index)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="section">
            <h3>变体属性</h3>
            <h3>PS：变更变体数量后，请对应修改变体属性</h3>
            <div class="action-buttons">
                <el-button type="primary" size="small" @click="handleAddAttribute">添加变体属性</el-button>
            </div>
            <el-table :data="variantAttributes" border height="300px">
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center;">
                            <div :style="{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: scope.row.savedAttributeData && scope.row.savedAttributeData.id ? '#67C23A' : '#F56C6C',
                                marginRight: '5px'
                            }"></div>
                            {{ scope.$index + 1 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="平台" prop="platform">
                    <template slot-scope="scope">
                        <span>亚马逊</span>
                    </template>
                </el-table-column>
                <el-table-column label="国家" prop="country">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.country" placeholder="请选择国家"
                            @change="handleCountryChange(scope.row)" filterable>
                            <el-option v-for="item in countryList" :key="item.id" :label="item.countryChinese"
                                :value="item.marketPlaceId">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="产品类型/分类" prop="category">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.category" placeholder="请选择产品类型"
                            @change="handleProductTypeChange(scope.row)" filterable>
                            <el-option v-for="item in productTypeList" :key="item.id" :label="item.displayChineseName"
                                :value="item.displayName">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="变体主题" prop="theme">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.theme" placeholder="请选择变体主题" filterable
                            @change="handleThemeChange(scope.row)">
                            <el-option v-for="item in variantThemeList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleEditVariant(scope.row)">编辑变体</el-button>
                        <el-button type="text" @click="handleDeleteAttribute(scope.$index)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 关联产品弹窗 -->
        <el-dialog title="关联SKU" :visible.sync="relateDialogVisible" width="70%" append-to-body>
            <div class="search-bar">
                <el-input v-model="searchKey" placeholder="SKU" style="width: 200px;margin-right: 20px;"></el-input>
                <el-button type="primary" @click="handleSearch">搜索</el-button>
            </div>
            <el-table :data="searchResults" border @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="图片" width="100">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.imagesJson.mainImages[0]"
                            :preview-src-list="scope.row.imagesJson.mainImages"
                            style="width: 50px; height: 50px;"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name"></el-table-column>
                <el-table-column label="SKU" prop="sku"></el-table-column>
                <el-table-column label="型号" prop="model"></el-table-column>
                <el-table-column label="品牌" prop="brand"></el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="relateDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirmRelate">确定关联</el-button>
            </div>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalResults">
                </el-pagination>
            </div>
        </el-dialog>
        <!-- 编辑变体弹窗 -->
        <el-dialog title="变体属性" :visible.sync="editVariantDialogVisible" width="1200px" append-to-body
            @close="handleEditDialogClose">
            <el-table :data="relatedProducts" border v-if="currentEditVariant">
                <el-table-column label="序号" width="60">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column label="SKU" prop="sku" width="320">
                    <template slot-scope="scope">
                        <span>{{ scope.row.sku || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="名称" prop="name" width="320">
                    <template slot-scope="scope">
                        <span>{{ scope.row.name || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-for="(variant, index) in getCurrentVariantColumns()" :key="index" :label="variant">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row['variant' + (index + 1)]" placeholder="请输入"
                            size="small"></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editVariantDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSaveVariant">
                    {{ currentEditVariant && currentEditVariant.savedAttributeData &&
                        currentEditVariant.savedAttributeData.id ?
                        '修改' : '创建' }}
                </el-button>
            </div>
        </el-dialog>
        <!-- 图片选择弹窗 -->
        <el-dialog title="选择图片" :visible.sync="showImageDialog" width="80%" :modal-append-to-body="false">
            <div class="image-list">
                <div v-for="img in currentVariantImages" :key="img" class="image-item" @click="selectImage(img)">
                    <el-image :src="img" fit="cover" style="width: 160px; height: 160px;"></el-image>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
    name: 'VariantAttributes',
    props: {
        formData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            variantAttributes: [],
            relatedProducts: [],
            newVariants: [],
            relateDialogVisible: false,
            searchKey: '',
            searchResults: [],
            selectedItems: [],
            countryList: [],
            productTypeList: [],
            variantThemeList: [],
            marketplaceId: '',
            editVariantDialogVisible: false,
            currentEditVariant: null,
            originalEditVariant: null,
            variantOptions: {},
            totalResults: 0,
            currentPage: 1,
            pageSize: 10,
            showImageDialog: false,
            currentVariantImages: [],
            currentSelectedVariant: null,
            savedVariantAttributeData: null
        }
    },
    computed: {
        allVariants() {
            return [...this.relatedProducts, ...this.newVariants]
        }
    },
    watch: {
        'formData.variantAttributes': {
            handler(val) {
                if (val) {
                    this.variantAttributes = val
                }
            },
            immediate: true
        },
        'formData.variants': {
            handler(val) {
                if (val) {
                    this.relatedProducts = val
                }
            },
            immediate: true
        },
        formData: {
            handler(newVal) {
                if (Array.isArray(newVal.children) && newVal.children.length > 0) {
                    if (JSON.stringify(this.relatedProducts) !== JSON.stringify(newVal.children)) {
                        this.relatedProducts = newVal.children
                    }
                }
                if (newVal.id && (!this.savedVariantAttributeData || this.savedVariantAttributeData.length === 0)) {
                    this.getVariantAttributeData(newVal.id);
                }
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.getCountryList()
    },
    methods: {
        async getCountryList() {
            try {
                const res = await ajaxPost(`${Baseurl}countryMarketController/selectCountryMarketList`)
                if (res.data.code === 200) {
                    this.countryList = res.data.data
                }
            } catch (error) {
                console.error('获取国家列表失败:', error)
            }
        },
        async getProductTypes(country) {
            try {
                const res = await ajaxPost(`${Baseurl}amazonProductType/getProductTypes`, country)
                if (res.data.code === 200) {
                    this.productTypeList = res.data.data
                }
            } catch (error) {
                console.error('获取产品类型失败:', error)
            }
        },
        async getVariantThemes(productType) {
            let paramsData = {
                marketplaceId: this.marketplaceId,
                productType: 'INK_OR_TONER'
                //productType
            }
            try {
                const res = await ajaxPost(`${Baseurl}amazonProductTypeDefinitionSchema/amazonProductTypeDefinitionSchemas`, paramsData)
                if (res.data.code === 200) {
                    let data = res.data.data
                    for (let i = 0; i < data[0].children.length; i++) {
                        if (data[0].children[i].property == 'variation_theme') {
                            this.variantThemeList = JSON.parse(data[0].children[i].children[0].enumValue)
                        }
                    }
                }
            } catch (error) {
                console.error('获取变体主题失败:', error)
            }
        },
        async handleCountryChange(row) {
            if (row.country) {
                this.marketplaceId = row.country
                await this.getProductTypes({ marketplaceIds: row.country })
            }
        },
        async handleProductTypeChange(row) {
            if (row.category) {
                await this.getVariantThemes(row.category)
            }
        },
        handleAddAttribute() {
            this.variantAttributes.push({
                platform: 'amazon',
                country: '',
                category: '',
                theme: '',
                variant1: '',
                variant2: ''
            })
        },
        handleDeleteAttribute(index) {
            this.$confirm('确定要删除该变体属性吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const attributeToDelete = this.variantAttributes[index];
                // 如果有已保存的数据，则调用删除接口
                if (attributeToDelete.savedAttributeData && attributeToDelete.savedAttributeData.id) {
                    try {
                        const params = {
                            id: attributeToDelete.savedAttributeData.id
                        };
                        const response = await ajaxPost(`${Baseurl}productAttribute/deleteProductAttribute`, params);
                        if (response.data.code === 200) {
                            this.$message.success('删除变体属性成功!');
                            this.variantAttributes.splice(index, 1);
                            this.updateFormData();
                        } else {
                            this.$message.error(response.data.msg || '删除变体属性失败!');
                        }
                    } catch (error) {
                        console.error('删除变体属性失败:', error);
                        this.$message.error('删除变体属性失败，请重试!');
                    }
                } else {
                    // 如果没有已保存的数据，直接从本地数组中删除
                    this.variantAttributes.splice(index, 1);
                    this.updateFormData();
                    this.$message.success('移除变体属性成功!');
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleAddRelatedProduct() {
            this.relateDialogVisible = true
            this.handleSearch()
            this.searchResults = []
            this.selectedItems = []
        },
        handleAddNewVariant() {
            this.newVariants.push({
                isNew: true,
                name: '',
                sku: '',
                model: '',
                brand: '',
                description: '',
                parentageLevel: 'child'
            })
        },
        handleDeleteProduct(index) {
            this.$confirm('确定要移除该关联吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (index < this.relatedProducts.length) {
                    const productToRemove = this.relatedProducts[index];
                    const params = {
                        parentId: this.formData.id,
                        childId: productToRemove.id
                    };
                    try {
                        const response = await ajaxPost(`${Baseurl}productParentageLevel/deleteProductParentageLevel`, params);
                        if (response.data.code === 200) {
                            this.$message.success('移除关联成功！');
                            this.relatedProducts.splice(index, 1);
                            this.updateFormData();
                        } else {
                            this.$message.error(response.data.msg || '移除关联失败！');
                        }
                    } catch (error) {
                        console.error('移除关联失败:', error);
                        this.$message.error('移除关联失败，请重试!');
                    }
                } else {
                    const newIndex = index - this.relatedProducts.length;
                    this.newVariants.splice(newIndex, 1);
                    this.updateFormData();
                    this.$message.success('移除成功！');
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消移除'
                });
            });
        },
        async handleSearch() {
            try {
                const response = await ajaxPost(`${Baseurl}productController/selectNotHasParentProductLibraryPage`, {
                    status: 1,
                    companyId: 9,
                    page: this.currentPage,
                    size: this.pageSize,
                    searchStr: this.searchKey
                });
                if (response.data.code === 200) {
                    this.searchResults = response.data.data.list;
                    this.totalResults = response.data.data.total;
                } else {
                    this.$message.error(response.data.msg || '获取数据失败!');
                }
            } catch (error) {
                console.error('获取数据失败:', error);
                this.$message.error('获取数据失败，请重试!');
            }
        },
        handleSelectionChange(val) {
            this.selectedItems = val
        },
        handleConfirmRelate() {
            if (this.selectedItems.length === 0) {
                this.$message.warning('请选择至少一个产品');
                return;
            }
            // 提取选中的 ID
            const childIds = this.selectedItems.map(item => item.id);
            const params = {
                parentId: this.formData.id,
                childIds: childIds
            };
            ajaxPost(`${Baseurl}productParentageLevel/createProductParentageLevel`, params)
                .then(response => {
                    if (response.data.code === 200) {
                        this.$message.success('关联产品成功！');
                        // 将选中的项添加到 relatedProducts
                        this.selectedItems.forEach(item => {
                            if (!this.relatedProducts.find(p => p.id === item.id)) {
                                this.relatedProducts.push({
                                    ...item
                                });
                            }
                        });
                        this.relateDialogVisible = false;
                        this.handleSearch();
                    } else {
                        this.$message.error('关联产品失败!');
                    }
                })
                .catch(error => {
                    console.error('关联产品失败:', error);
                    this.$message.error('关联产品失败，请重试!');
                });
        },
        async handleSubmit() {
            if (!this.formData.id) {
                this.$message.warning('请先创建产品基本信息')
                return
            }
            try {
                const invalidVariants = this.newVariants.filter(variant => !variant.sku || !variant.name)
                if (invalidVariants.length > 0) {
                    this.$message.warning('请填写所有变体的 SKU 和名称')
                    return
                }
                const userInfo = JSON.parse(localStorage.getItem("role"))
                const children = this.newVariants.map(variant => ({
                    name: variant.name,
                    sku: variant.sku,
                    model: variant.model,
                    brand: variant.brand,
                    parentageLevel: 'child',
                    companyId: userInfo.company_id,
                    rid: userInfo.rid,
                    imagesJson: variant.imagesJson || this.formData.imagesJson
                }))
                if (children.length > 0) {
                    const response = await ajaxPost(`${Baseurl}productController/updateProductLibrary`, {
                        id: this.formData.id,
                        children: children
                    })
                    if (response.data.code === 200) {
                        this.$message.success('保存变体信息成功!')
                        // 将newVariants中的isNew属性修改为false
                        this.newVariants.forEach(variant => {
                            variant.isNew = false;
                        });
                        // 将newVariants中的数据转移到relatedProducts
                        this.relatedProducts = [...this.relatedProducts, ...this.newVariants];
                        // 清空newVariants
                        this.newVariants = [];
                    } else {
                        this.$message.error(response.data.msg || '保存变体信息失败!')
                    }
                } else {
                    this.$message.success('保存变体信息成功!')
                    // 将newVariants中的isNew属性修改为false
                    this.newVariants.forEach(variant => {
                        variant.isNew = false;
                    });
                    // 将newVariants中的数据转移到relatedProducts
                    this.relatedProducts = [...this.relatedProducts, ...this.newVariants];
                    // 清空newVariants
                    this.newVariants = [];
                }
                this.updateFormData()
            } catch (error) {
                console.error('保存失败:', error)
                this.$message.error('保存变体信息失败，请重试!')
            }
        },
        updateFormData() {
            this.$emit('update:formData', {
                ...this.formData,
                variantAttributes: this.variantAttributes,
                variants: this.allVariants,
                children: this.allVariants
            })
        },
        handleThemeChange(row) {
            row.variant1 = ''
            row.variant2 = ''
            row.variant3 = ''
            row.variant4 = ''
            row.variant5 = ''
            this.getVariantOptionsForTheme(row)
        },
        handleEditVariant(row) {
            // 检查是否有未保存的变体信息
            const hasUnsavedVariants = this.newVariants.length > 0;
            if (hasUnsavedVariants) {
                this.$message.warning('请先保存未保存的变体信息，然后再编辑变体属性!');
                return;
            }
            // 保存原始数据
            this.originalEditVariant = JSON.parse(JSON.stringify(row));
            // 创建编辑副本
            this.currentEditVariant = JSON.parse(JSON.stringify(row));
            // 过滤出有效的变体
            const validProducts = this.allVariants.filter(variant => {
                // 如果是新增的变体，必须填写必要信息
                if (variant.isNew) {
                    return variant.sku && variant.name;
                }
                // 如果是已保存的变体，直接通过
                return true;
            });
            
            // 深拷贝有效的变体数据
            this.relatedProducts = JSON.parse(JSON.stringify(validProducts));
            // 如果有已保存的属性数据，则解析并匹配SKU
            if (row.savedAttributeData && row.savedAttributeData.attribute) {
                try {
                    const attributeArray = JSON.parse(row.savedAttributeData.attribute);
                    if (Array.isArray(attributeArray) && attributeArray.length > 0) {
                        // 获取变体主题的各个部分
                        const themeParts = row.theme.split('/');
                        // 确保每个变体都有对应的属性字段
                        this.relatedProducts = this.relatedProducts.map(variant => {
                            const matchedAttribute = attributeArray.find(attr => attr.sku === variant.sku);
                            if (matchedAttribute) {
                                const newVariant = { ...variant };
                                themeParts.forEach((part, index) => {
                                    const key = part.toLowerCase();
                                    const value = matchedAttribute[key];
                                    if (value) {
                                        newVariant['variant' + (index + 1)] = value;
                                    }
                                });
                                return newVariant;
                            }
                            return variant;
                        });
                    }
                } catch (e) {
                    console.error('解析属性数据失败:', e);
                }
            }
            
            // 打开编辑弹窗
            this.editVariantDialogVisible = true;
        },
        async handleSaveVariant() {
            if (this.currentEditVariant) {
                try {
                    // 获取变体主题的各个部分
                    const variantThemeParts = this.currentEditVariant.theme.split('/');
                    // 验证所有变体是否都填写了必要的属性
                    let hasEmptyValues = false;
                    let emptyFields = [];
                    this.relatedProducts.forEach(variant => {
                        variantThemeParts.forEach((themePart, index) => {
                            const key = 'variant' + (index + 1);
                            if (!variant[key] || variant[key].trim() === '') {
                                hasEmptyValues = true;
                                emptyFields.push(`${variant.sku} 的 ${themePart}`);
                            }
                        });
                    });
                    // 如果有空值，显示错误信息并返回
                    if (hasEmptyValues) {
                        this.$message.error(`以下字段为必填项：${emptyFields.join(', ')}`);
                        return;
                    }
                    // 构建请求参数
                    const skuAttributeJsonArray = this.relatedProducts.map(variant => {
                        const attributes = { sku: variant.sku };
                        variantThemeParts.forEach((themePart, index) => {
                            const key = themePart.toLowerCase();
                            attributes[key] = variant['variant' + (index + 1)];
                        });
                        return attributes;
                    });
                    // 通用请求参数
                    const params = {
                        productId: this.formData.id,
                        platform: this.currentEditVariant.platform || 'amazon',
                        countryCode: this.getCountryCode(this.currentEditVariant.country),
                        productType: this.currentEditVariant.category,
                        variationTheme: this.currentEditVariant.theme,
                        skuAttributeJsonArray: skuAttributeJsonArray
                    };
                    let response;
                    let actionType;
                    // 判断是修改还是创建
                    if (this.currentEditVariant.savedAttributeData && this.currentEditVariant.savedAttributeData.id) {
                        actionType = '修改';
                        params.id = this.currentEditVariant.savedAttributeData.id;
                        response = await ajaxPost(`${Baseurl}productAttribute/updateProductAttribute`, params);
                    } else {
                        actionType = '创建';
                        response = await ajaxPost(`${Baseurl}productAttribute/createProductAttribute`, params);
                    }
                    if (response.data.code === 200) {
                        this.$message.success(`${actionType}变体属性成功!`);
                        this.variantAttributes = []
                        await this.getVariantAttributeData(this.formData.id)
                        this.editVariantDialogVisible = false;
                        this.updateFormData()
                    } else {
                        this.$message.error(response.data.msg || `${actionType}变体属性失败!`);
                    }
                } catch (error) {
                    console.error('保存变体属性失败:', error);
                    this.$message.error('操作变体属性失败，请重试!');
                }
            }
        },
        getCountryCode(marketplaceId) {
            const country = this.countryList.find(item => item.marketPlaceId === marketplaceId);
            return country ? country.countryCode : '';
        },
        getCurrentVariantColumns() {
            if (!this.currentEditVariant || !this.currentEditVariant.theme) return []
            return this.currentEditVariant.theme.split('/')
        },
        getVariantOptions(index) {
            if (!this.currentEditVariant || !this.currentEditVariant.theme) return []
            const theme = this.currentEditVariant.theme
            return this.variantOptions[theme]?.[index - 1] || []
        },
        async getVariantOptionsForTheme(row) {
            if (!row.theme) return
            const theme = row.theme
            const options = {}
            const parts = theme.split('/')
            parts.forEach((part, index) => {
                const values = new Set()
                this.allVariants.forEach(variant => {
                    if (variant['variant' + (index + 1)]) {
                        values.add(variant['variant' + (index + 1)])
                    }
                })
                options[index] = Array.from(values)
            })
            this.$set(this.variantOptions, theme, options)
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.handleSearch();
        },
        handleSelectImage(variant) {
            if (variant.isNew == true) {
                this.currentSelectedVariant = variant;
                this.currentVariantImages = JSON.parse(this.formData.images)?.mainImages || []
                this.showImageDialog = true;
            }
        },
        selectImage(img) {
            if (this.currentSelectedVariant) {
                if (!this.currentSelectedVariant.imagesJson) {
                    this.$set(this.currentSelectedVariant, 'imagesJson', {});
                }
                if (!this.currentSelectedVariant.imagesJson.mainImages) {
                    this.$set(this.currentSelectedVariant.imagesJson, 'mainImages', []);
                }
                this.currentSelectedVariant.imagesJson.mainImages = [img];
                this.showImageDialog = false;
            }
        },
        async getVariantAttributeData(productId) {
            try {
                const params = {
                    productId: productId
                };
                const response = await ajaxPost(`${Baseurl}productAttribute/selectProductAttributeList`, params);
                if (response.data.code === 200 && response.data.data && response.data.data.length > 0) {
                    this.savedVariantAttributeData = response.data.data;
                    // 先确保国家列表已加载
                    if (this.countryList.length === 0) {
                        await this.getCountryList();
                    }
                    const newVariantAttributes = [];
                    this.savedVariantAttributeData.forEach(item => {
                        const country = this.countryList.find(c => c.countryCode === item.countryCode);
                        const countryId = country ? country.marketPlaceId : '';
                        const existingAttribute = this.variantAttributes.find(
                            attr => attr.savedAttributeData && attr.savedAttributeData.id === item.id
                        );
                        if (existingAttribute) {
                            existingAttribute.savedAttributeData = item;
                            newVariantAttributes.push(existingAttribute);
                        } else {
                            const variantAttribute = {
                                platform: item.platform || 'amazon',
                                country: countryId,
                                category: item.productType,
                                theme: item.variationTheme,
                                variant1: '',
                                variant2: '',
                                savedAttributeData: item
                            };
                            newVariantAttributes.push(variantAttribute);
                        }
                    });
                    // 保留未保存的变体属性
                    const unsavedAttributes = this.variantAttributes.filter(
                        attr => !attr.savedAttributeData || !attr.savedAttributeData.id
                    );
                    // 合并已保存和未保存的变体属性
                    this.variantAttributes = [...newVariantAttributes, ...unsavedAttributes];
                    // 更新国家和产品类型相关数据
                    this.variantAttributes.forEach(async (attr) => {
                        if (attr.country && attr.category) {
                            this.marketplaceId = attr.country;
                        }
                    });
                    // 更新表单数据
                    this.updateFormData();
                }
            } catch (error) {
                console.error('获取变体属性数据失败:', error);
            }
        },
        handleEditDialogClose() {
            // 关闭弹框时恢复变体信息
            if (this.formData.id) {
                this.getVariantAttributeData(this.formData.id);
            }
            // 确保变体信息不会丢失
            this.updateFormData();
        },
    }
}
</script>

<style lang="scss" scoped>
.variant-attributes {
    .section {
        margin-bottom: 80px;

        h3 {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: bold;
        }
    }

    .action-buttons {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
    }

    .search-bar {
        margin-bottom: 15px;
        display: flex;
        gap: 10px;
    }

    :deep(.el-table) {
        overflow-y: auto;
        margin-bottom: 20px;

        .el-image {
            width: 50px;
            height: 50px;
            display: block;
        }
    }

    .required {
        color: #F56C6C;
        margin-right: 4px;
    }
}

.w-100 {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.image-container {
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
}

.image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 10px;
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: hidden;

    .image-item {
        cursor: pointer;
        border: 2px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        transition: all 0.3s;
        position: relative;
        width: 160px;
        height: 160px;
        flex-shrink: 0;

        &:hover {
            border-color: #409EFF;
            transform: translateY(-2px);
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        }

        &.active {
            border-color: #409EFF;

            &::after {
                content: '✓';
                position: absolute;
                right: 5px;
                top: 5px;
                width: 20px;
                height: 20px;
                background: #409EFF;
                color: #fff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
            }
        }
    }
}
</style>